webpackJsonp([8806258911236],{

/***/ 557:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Nick Long's Blog","subtitle":"Engineer & Musician","copyright":"© Nick Long 2018 All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"}],"author":{"name":"Nick Long","email":"#","telegram":"#","twitter":"monquixote","github":"monquixote","rss":"./rss.xml","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/the-saboteur-is-a-terrible-game-so-why-did-i-play-it-to-the-end/","categorySlug":"/categories/review/"},"frontmatter":{"title":"The Saboteur is a terrible game - So why did I play it to the end?","date":"2010-12-10T23:19:00.000Z","category":"Review","description":null}}}]}},"pathContext":{"tag":"reviews"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-reviews-c30f420ba92f1101ba52.js